import type { NotificationsResponse } from '@ledokol/contracts'
import { api } from './client'

export async function fetchNotifications(): Promise<NotificationsResponse> {
  const r = await api.get<NotificationsResponse>('/notifications')
  return r.data
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.post(`/notifications/${id}/read`)
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post('/notifications/read-all')
}
